import { SceneModel } from "./scene.model";
import React from "react";

export const SceneContext = React.createContext<SceneModel>(null as any);
